export default __webpack_public_path__ + "static/p7-c5ea92dfa14419580530c084447fc41e.png";